import { defineStore } from 'pinia'
import { fetchAreas } from '@/api/address'
import { path } from '@/utils/tools'

export default defineStore('area', {
  state: () => {
    return {
      province: [],
      isRequest: false
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'area',
        storage: localStorage,
        paths: ['province']
      }
    ]
  },
  // 注意：state的成员名称 与 getter成员名称不能相同
  getters: {
    getProvince: (state) => state.province
  },
  // actions 支持async/await, actions之间方法互相调用直接用this访问即可
  actions: {
    async onGetFetchAreas(code: number | string) {
      try {
        const data = await fetchAreas(code)
        if (code === 0) this.province = path(data, 'data', [])
        this.isRequest = true
        return path(data, 'data', [])
      } catch (error) {
        console.log('onGetFetchAreas-->', error)
      }
    }
  }
})
